export default __webpack_public_path__ + "static/media/icons8-full-tool-storage-box.cc38e10a.svg";